module.exports = "/_next/static/images/6be854af7949feca4f0d0a1d1424a342-mockup-transfer@0.5x.jpg";